import './SectionHeading.css'

const SectionHeading = () => {

  return (
    <div className="section-heading text-center" data-aos="fade-up">
        <h2 className="title-head-subscribe">Don’t Miss ICO News And Updates!</h2>
        <p className="text-head-subscribe">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed quis accumsan nisi Ut ut felis congue nisl hendrerit commodo.</p>
    </div>
  );
}

export default SectionHeading;